// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__3OWDW","title":"Images90_title__3NFJR","images":"Images90_images__cwy0K"};